import { Icon, IconButton, Modal } from "@material-ui/core";
import React, { FC, memo, useEffect, useState } from "react";
import styles from "./Catalog.module.scss";
import { Categories } from "./components/categories/Categories";
import { ProductDetail } from "./components/productDetail/ProductDetail";
import { ProductListSkeleton } from "./components/products/ProductListSkeleton";
import Toolbar from "./components/toolbar/Toolbar";
import { useCatalogHook } from "./UseCatalog";
import { OrientationType } from "application/contexts/screen/ScreenStore";
import { ProductKilo } from "./components/productKilo/ProductKilo";
import { Products } from "./components/products/Products";
import { WeighingProductSelect } from "./components/weighingProductSelect/WeighingProductSelect";

export interface ICatalog { }

const Catalog: FC<ICatalog> = memo(() => {
  const {
    modalValues,
    openProductDetail,
    closeProductDetailModal,
    store,
    categoryPosition,
    productListRef,
    seccionedProductsFiltered,
    handleCategoryClick,
    handleChangeCategory,
    animate,
    closeCategory,
    openCategory,
    hideCategory,
    orientation,
    focus,
    refDiv,
    weighingSelectProducts,
    onWeighingProductSelect,
    onWeighingSelectClose,
  } = useCatalogHook();

  if (!store) {
    return <></>;
  }

  return (
    <div id={styles.Catalog} onClick={focus} ref={refDiv}>
      <Toolbar title={store.name} />
      <div className={styles.container}>
        <div className={styles.categoryContainer}>
          <Categories
            hideCategory={hideCategory}
            position={categoryPosition}
            onClick={handleCategoryClick}
            seccionedProdect={seccionedProductsFiltered}
          />
          <IconButton
            className={styles.menuButton}
            onClick={hideCategory ? openCategory : closeCategory}
          >
            <Icon>{hideCategory ? "chevron_right" : "chevron_left"}</Icon>
          </IconButton>
        </div>
          <Products
            ref={productListRef}
            hideCategory={hideCategory}
            isClosed={store?.isClosed}
            seccionedProducts={seccionedProductsFiltered}
            onChangeCategory={handleChangeCategory}
            openDetail={openProductDetail}
          />
      </div>

      <Modal
        open={modalValues.open}
        onClose={closeProductDetailModal}
        BackdropProps={{
          style: {
            backdropFilter: "none",
          },
        }}
      >
        <div
          className={styles.productDetailModal}
          style={{
            transform: animate ? "translate(-50%, 0)" : "translate(-50%, 100%)",
            transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
            opacity: animate ? 1 : 0,
          }}
        >
          <div
            className={styles.content}
            style={{
              height:
                orientation === OrientationType.LANDSCAPE ? "calc(95 * var(--vh, 1vh))" : "calc(80 * var(--vh, 1vh))",
            }}
          >
            {modalValues?.product && modalValues.open && (
              <ProductDetail
                onClose={closeProductDetailModal}
                product={modalValues.product}
              />
            )}
          </div>
        </div>
      </Modal>
      <Modal
        open={!!modalValues?.openWeighing}
        onClose={closeProductDetailModal}
        BackdropProps={{
          style: {
            backdropFilter: "none",
          },
        }}
      >
        <div
          className={styles.productKiloModal}
          style={{
            transform: animate ? "translate(-50%, 0)" : "translate(-50%, 100%)",
            transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
            opacity: animate ? 1 : 0,
          }}
        >
          <div
            className={styles.content}
            style={{
              height:
                orientation === OrientationType.LANDSCAPE ? "calc(75 * var(--vh, 1vh))" : "calc(70 * var(--vh, 1vh))",
            }}
          >
            {modalValues?.product && modalValues.openWeighing && (
              <ProductKilo
                onClose={closeProductDetailModal}
                product={modalValues.product}
                store={store}
              />
            )}
          </div>
        </div>
      </Modal>
      <Modal
        open={weighingSelectProducts.length > 0}
        onClose={onWeighingSelectClose}
        BackdropProps={{ style: { backdropFilter: "none" } }}
      >
        <div
          className={styles.productKiloModal}
          style={{
            transform: weighingSelectProducts.length > 0 ? "translate(-50%, 0)" : "translate(-50%, 100%)",
            transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
            opacity: weighingSelectProducts.length > 0 ? 1 : 0,
          }}
        >
          <div className={styles.content}>
            <WeighingProductSelect
              products={weighingSelectProducts}
              onSelect={onWeighingProductSelect}
              onClose={onWeighingSelectClose}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
});

export default Catalog;
